/**
 * Detect mobile browser for memory-constrained DuckDB / UI paths.
 */
export const isMobileBrowser = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  if (typeof window === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 0 && window.innerWidth < 768);
};
